var mods = {};
module.exports = mods;

// 支付渠道
// alipay_qr:支付宝正扫
// alipay_wap: 支付宝H5支付
// wx_qr:微信正扫
// wx_pub: 微信H5支付
// alipay_lite: 支付宝小程序
mods.channelConfig = {
    alipay_qr: "alipay_qr",
    alipay_wap: "alipay_wap",
    wx_qr: "wx_qr",
    wx_pub: "wx_pub",
    alipay_lite: "alipay_lite"
}

// ["alipay_qr", "alipay_wap", "wx_qr", "wx_pub", "alipay_lite"]

// payment参数校验结果
mods.chackMsg = {
    orderError: '发起支付失败',
    channelError: '支付渠道参数错误',
    amountError: '支付金额参数错误',
    queryUrlError: '支付结果url参数未知'
}

// 支付状态值
mods.payStatus = {
    succeeded: "succeeded",
    failed: "failed",
    pending: "pending",
    timeout: "timeout",
    cancel: "unknown",
    unknown: "unknown",
    paramError: "paramError"
}
// 支付结果对象
mods.payResult = {
    succeeded: {
        result_status: mods.payStatus.succeeded,
        result_message: "订单支付成功",
        result_info: {}
    },

    failed: {
        result_status: mods.payStatus.failed,
        result_message: "订单支付失败",
        result_info: {}
    },

    pending: {
        result_status: mods.payStatus.pending,
        result_message: "订单支付中",
        result_info: {}
    },

    timeout: {
        result_status: mods.payStatus.timeout,
        result_message: "订单支付超时",
        result_info: {}
    },

    cancel: {
        result_status: mods.payStatus.cancel,
        result_message: "支付取消",
        result_info: {}
    },

    unknown: {
        result_status: mods.payStatus.unknown,
        result_message: "订单结果未知",
        result_info: {}
    },

    paramError: {
        result_status: mods.payStatus.paramError,
        result_message: "参数错误",
        result_info: {}
    }
}




// WEBPACK FOOTER //
// ./src/mods.js